import { FormContainerStepProps } from 'components';
import { useTranslation } from 'libs/i18n';
import {
  ClientType,
  FormBodyWrapper,
} from 'modules/onboarding/common/components';

import {
  TargetedFinancialInstrumentsFormType,
  getSchema,
  FormErrors,
} from '../../forms/targetedFinancialInstrumentsForm';

import { FormContent } from './FormContent';

interface TargetedFinancialInstrumentsProps extends FormContainerStepProps {
  initialValues?: TargetedFinancialInstrumentsFormType;
  onSubmit: (values: TargetedFinancialInstrumentsFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  clientType?: ClientType;
}

export const TargetedFinancialInstruments = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  formError,
  onSubmit,
  step,
  clientType,
  ...formProps
}: TargetedFinancialInstrumentsProps) => {
  const schema = getSchema();
  const { t } = useTranslation();
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      step={step}
      submitLoading={submitLoading}
      subTitle={t('onboarding.targetedFinancialInstruments.subtitle')}
      title={t('onboarding.targetedFinancialInstruments.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormBodyWrapper>
  );
};
